import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import Link from "next/link";

function MarkdownLink(props) {
  const { node } = props;

  const { properties } = node;

  if (!isEmpty(node.children) && node.children.type === "text") {
    return null;
  }

  const anchorClassname = classNames(node.properties?.className);

  return (
    <Link {...properties} className={anchorClassname}>
      {node.children[0].value}
    </Link>
  );
}

export default MarkdownLink;
